import { app } from '../../../../../app';
import { Controller } from './edit-ip-address-filter.controller';

app.component('editCorporateIpAddressFilter', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./edit-ip-address-filter.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/corporate-settings/company-profile/edit-ip-address-filter/edit-ip-address-filter.component.js